import { isDev } from '~~/services/common';
import { getPosthog, loadPosthog, markPosthogLoading } from '~~/services/analytics';

export default defineNuxtPlugin(() => {
    if (isDev()) {
        return;
    }
    const config = useRuntimeConfig();
    const key = config.public.posthogKey as string;
    if (!key) {
        return;
    }
    // Queue events from now on, but only download PostHog once the page is interactive
    // (onNuxtReady runs after hydration, in an idle callback), keeping it off the critical path.
    markPosthogLoading();
    onNuxtReady(() => loadPosthog(key));

    return {
        provide: {
            posthog: getPosthog,
        },
    };
});
